import { render } from "./App.vue?vue&type=template&id=1672dbc7&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1672dbc7&lang=css"
import "@/assets/Css/app.css?vue&type=style&index=1&id=1672dbc7&scoped=true&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1672dbc7"]])

export default __exports__